import { useRef } from 'react';
import { motion, useReducedMotion, useInView } from 'framer-motion';

export function FadeIn({
    children,
    delay = 0,
    y = 24,
    duration = 0.55,
    sx = {}
}) {
    const reduce = useReducedMotion();
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: '-60px' });
    const show = inView || reduce;

    return (
        <motion.div
            ref={ref}
            initial={false}
            animate={{ opacity: show ? 1 : 0, y: show ? 0 : (reduce ? 0 : y) }}
            transition={reduce ? { duration: 0 } : { duration, delay, ease: [0.25, 0.1, 0.25, 1] }}
            style={sx}
        >
            {children}
        </motion.div >
    );
}
